import React from 'react';
import { Logo } from '../Logo';
import { ThemeToggle } from '../ThemeToggle';
import { profile } from '../../data/profile';
export function MobileHeader() {
  return <header className="sticky top-0 z-40 border-b border-line bg-canvas/90 backdrop-blur lg:hidden" data-id="element-254" data-mp="3m74kb2e6zv68">
      <div className="flex items-center justify-between px-5 py-3 md:px-8" data-id="element-255" data-mp="3r67rasdqgbgu">
        <a href="#top" className="flex items-center gap-2.5" data-id="element-256" data-mp="3r8ae73jl9ohc">
          <Logo className="h-8 w-8" data-id="element-257" data-mp="irfnsnjz9wk5" />
          <span className="text-sm font-semibold text-fg" data-id="element-258" data-mp="ish8ljqspxf2">{profile.name}</span>
        </a>
        <div className="flex items-center gap-2" data-id="element-259" data-mp="nopioiq4z0fd">
          <ThemeToggle data-id="element-260" data-mp="914j2ysgzjc7" />
          <a href={`mailto:${profile.email}`} className="rounded-full bg-ink px-4 py-2 text-xs font-medium text-white transition-transform duration-150 ease-out active:scale-[0.97]" data-id="element-261" data-mp="8ztdctfgs1ig">
            Let's talk
          </a>
        </div>
      </div>
    </header>;
}